// @flow

export const hasVersion = (key: ?string) => {
  return (key || '').includes('@');
};

export const stripVersion = (key: ?string) => {
  key = key || '';
  return key.split('@')[0];
};

export const getVersion = (key: ?string) => {
  return (key || '').split('@')[1] || '';
};
